module.exports = __webpack_public_path__ + "static/img/kayi-logo-white.fbc7f9c.png";


//////////////////
// WEBPACK FOOTER
// ./packages/assets/kayi-logo-white.png
// module id = jacJ
// module chunks = 1